export default __webpack_public_path__ + "static/media/dash.390af90f.svg";